import { CSSProperties, SxProps } from '@mui/material';
import { ReactNode } from 'react';

export interface BrushboxBackgroundProps {
  color: 'red' | 'white' | 'black' | 'grey';
  style?: CSSProperties;
}

export enum BrushboxVariants {
  Wide = 'wide',
  Rectangle = 'rectangle',
  Tall = 'tall',
}

export enum BrushboxColors {
  Red = 'red',
  White = 'white',
  Black = 'black',
  Grey = 'grey',
}

export interface BrushboxProps {
  children: ReactNode;
  variant: BrushboxVariants;
  color: BrushboxColors;
  sx?: SxProps;
  brushSx?: SxProps;
}
